import React, { useEffect, useState } from 'react';

const AnalogClock = ({style}) => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const seconds = time.getSeconds();
  const minutes = time.getMinutes();
  const hours = time.getHours();

  const secondDeg = seconds * 6 -90;
  const minuteDeg = minutes * 6 + seconds * 0.1 -90;
  const hourDeg = ((hours % 12) / 12) * 360 + (minutes / 60) * 30 - 90;

  return (
    <div className={`clock-super-container-${style}`}>
      <div className={`digital-time-${style}`}>
        {time.toLocaleTimeString()}
      </div>
      <div className={`clock-container-${style}`}>
        <div className={`clock-${style}`}>
          <div className={`hand-${style} hour-${style}`} style={{ transform: `rotate(${hourDeg}deg)` }} />
          <div className={`hand-${style} minute-${style}`} style={{ transform: `rotate(${minuteDeg}deg)` }} />
          <div className={`hand-${style} second-${style}`} style={{ transform: `rotate(${secondDeg}deg)` }} />
          <div className={`center-dot-${style}`} />
        </div>
      </div>
      
      
    </div>
  );
};

export default AnalogClock;
